import React from 'react'
import { Outlet } from 'react-router-dom'
import Header from '../../components/common/Header'
import Footer from '../../components/common/Footer'

const HomepageLayout = () => {
  return (
    <>
      {/* 사용자페이지 */}
      <div className="App">
        <Header />
        <div className="container-lg py-5">
          <Outlet />
        </div>
        <Footer />
      </div>
    </>
  )
}

export default HomepageLayout
